import React from 'react';
import find from "lodash/find"
import "../Shared/Translate.js"

const html = `<react-component component="Authentication" props="getAuthenticationProps()"></react-component>`

type PageConfigInit = {
  AvailableLocales: string[];
  BannerLogoPath: string;
  ExternalLoginLinks: string[];
  HasIdentityServerLogin: boolean;
  IsNativeAppFlow: boolean;
  NativeAppRedirectUrl: string;
  ProductName: string;
  RedirectUrl: string;
  ReloginState: string;
}

$(document).ready(function () {
  if (!$(".participant-login-container").length) { return; }

  var pageConfigInit: PageConfigInit = JSON.parse(document.getElementById('AntiXssPageConfigInit').textContent);
  var module = angular.module("participantLoginModule", ['CareEvWidgets', 'ngRoute', 'ngCookies', 'ResearchKitApplicationModule', 'pascalprecht.translate']);

  module
    .constant("pageConfig", pageConfigInit)
    .constant("availableLocales", pageConfigInit.AvailableLocales)
    .value("externalLoginLinks", pageConfigInit.ExternalLoginLinks)

  module.component('participantLogin', {
    template: html,
    controller: 'participantLoginController',
    controllerAs: 'vm'
  });

  module.controller("participantLoginController",
    ["$scope", "$cookies", "$translate", "externalLoginLinks", function ($scope, $cookies, $translate, externalLoginLinks) {
      let authenticationProps = null;

      // angular-translate emits $translateChangeEnd on the Angular root scope
      //   Re-dispatch it on window for the React listeners to pick up
      $scope.$root.$on("$translateChangeEnd", function () {
        window.dispatchEvent(new CustomEvent("$translateChangeEnd"));
      });

      $scope.getAuthenticationProps = function () {
        const sessionCookieName = CareEv.ClientName + '.idsvr.session';
        const lastIdp = $cookies.get(CareEv.ClientName + 'LastIdentityProvider');
        var newProps = {
          availableLocales: pageConfigInit.AvailableLocales,
          cookies: $cookies,
          currentLanguage: $translate.proposedLanguage(),
          externalLoginLinks: pageConfigInit.ExternalLoginLinks,
          hasIdentityServerLogin: pageConfigInit.HasIdentityServerLogin,
          isNativeAppFlow: pageConfigInit.IsNativeAppFlow,
          lastIdp,
          lastLoginLink: find(externalLoginLinks, function (link) { return link.Id === lastIdp; }) || { Name: "Identity Provider" },
          lastSessionCookie: $cookies.get(sessionCookieName),
          nativeAppRedirectUrl: pageConfigInit.NativeAppRedirectUrl,
          productName: pageConfigInit.ProductName,
          redirectUrl: pageConfigInit.RedirectUrl,
          reloginState: pageConfigInit.ReloginState,
          sessionCookieName,
          translate: $translate
        }
        if (!angular.equals(authenticationProps, newProps)) {
          authenticationProps = newProps;
        }

        return authenticationProps;
      }
    }])

  module.config(["$translateProvider", "availableLocales", "translateConfigurationProvider",
    function ($translateProvider, availableLocales, translateConfigurationProvider) {
      translateConfigurationProvider.$get().configure($translateProvider, availableLocales);
    }]);

  angular.bootstrap($(".participant-login-container"), ["participantLoginModule"]);
});